import { render, staticRenderFns } from "./modalObservacaoConvenio.vue?vue&type=template&id=7eaf7e67&"
import script from "./modalObservacaoConvenio.vue?vue&type=script&lang=js&"
export * from "./modalObservacaoConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports